module.exports = __webpack_public_path__ + "static/pcg-hero.db9512af.webp";